export const DROPDOWN_DATA = Object.freeze({
  FONT: {
    OPTIONS: ['Noto Sans', 'Pretendard', '나눔명조', '나눔손글씨 손편지체'],
    DEFAULT: 'Noto Sans',
  },
  RELATIONSHIP: { OPTIONS: ['친구', '지인', '동료', '가족'], DEFAULT: '지인' },
});
